import { formatMessage } from 'src/utils';
import { GridSizeType, GameTileProps } from './types';
export const selectProperStyles = (
  style: {
    small: string | string[];
    medium: string | string[];
    default: string | string[];
  },
  size?: GridSizeType
) => {
  switch (size) {
    case 'small':
      return style.small;
    case 'medium':
      return style.medium;
    default:
      return style.default;
  }
};

export const sliceGameList = (
  expectedAmount: number,
  gameList: GameTileProps[] = []
): GameTileProps[] =>
  [...gameList, ...new Array(expectedAmount)].slice(0, expectedAmount);

export const prepareGameInfoTooltip = (
  gameInfoTooltip: string | undefined,
  gameTitle: string
) =>
  formatMessage(gameInfoTooltip, {
    gameTitle,
  });
